import {Injectable} from '@angular/core';
import {ComponentStore} from '@ngrx/component-store';
import {PortfolioInvitation} from 'src/app/domain/model/portfolio/portfolio-invitation.model';

export interface MyJointHolderInvitationState {
  invitation: PortfolioInvitation | null | undefined;
}

const emptyState = (): MyJointHolderInvitationState => ({
  invitation: undefined,
});

@Injectable({
  providedIn: 'root',
})
export default class MyJointHolderInvitationStore extends ComponentStore<MyJointHolderInvitationState> {
  public readonly invitation$ = this.select(state => state.invitation);

  constructor() {
    super(emptyState());
  }

  public save(invitation: PortfolioInvitation | null): void {
    this.patchState(() => ({invitation}));
  }

  public sync(): PortfolioInvitation | null | undefined {
    return this.get().invitation;
  }

  public reset(): void {
    this.patchState(() => emptyState());
  }
}
